/**
 * Delete Tool - Deletes selected elements
 */
import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';

export class DeleteTool extends BaseTool {
    id = 'DELETE';
    name = 'Delete';
    cursor = 'default';

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        const selection = this.context?.appStore.selectedIds || [];
        if (selection.length > 0) {
            selection.forEach(id => this.context?.bimStore.removeElement(id));
            this.context?.appStore.select([]);
            console.log('Deleted elements:', selection);
        } else {
            // Try to delete clicked element
            const id = this.findElementIdAtPoint(event);
            if (id) {
                this.context?.bimStore.removeElement(id);
                console.log('Deleted element:', id);
            }
        }
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerMove(): void { }
    onPointerUp(): void { }
}
